import { useState } from "react";
import { ArrowLeft, Users, BookOpen, Trophy, Calendar, HelpCircle, MessageSquare, Share2, FileText, Star, Heart, Send, Pin, Lock, Check, X, UserPlus } from "lucide-react";
import { Avatar, AvatarFallback } from "../ui/avatar";
import { useToast } from "../../hooks/use-toast";






const classDataMap = {
  1: { name: "CS201 — Data Structures", university: "Baku State University", description: "Comprehensive study of data structures and algorithms, including arrays, linked lists, trees, graphs, sorting, and dynamic programming.", members: 45, totalPoints: 2450, isPrivate: false, isJoined: true, userRole: "admin" },
  2: { name: "MATH301 — Linear Algebra", university: "ADA University", description: "Advanced linear algebra covering vector spaces, eigenvalues, matrix decompositions, and applications in data science.", members: 32, totalPoints: 1890, isPrivate: true, isJoined: true, userRole: "member" },
  3: { name: "CHEM101 — General Chemistry", university: "Baku Engineering University", description: "Introduction to general chemistry: atomic structure, chemical bonding, thermodynamics, and reaction kinetics.", members: 58, totalPoints: 3200, isPrivate: false, isJoined: true, userRole: "member" },
  4: { name: "PHYS202 — Electromagnetism", university: "Khazar University", description: "Maxwell's equations, electromagnetic waves, optics, and modern physics applications.", members: 28, totalPoints: 1560, isPrivate: true, isJoined: false, userRole: "" },
  5: { name: "CS101 — Intro to Programming", university: "ADA University", description: "Learn Python from scratch — variables, loops, functions, OOP, and file handling.", members: 72, totalPoints: 4100, isPrivate: false, isJoined: false, userRole: "" },
  6: { name: "ECON201 — Microeconomics", university: "Baku State University", description: "Supply and demand, market structures, consumer behavior, and game theory fundamentals.", members: 40, totalPoints: 2100, isPrivate: false, isJoined: false, userRole: "" },
  7: { name: "BIO301 — Molecular Biology", university: "ASOIU", description: "DNA replication, gene expression, protein synthesis, and molecular genetics techniques.", members: 22, totalPoints: 980, isPrivate: true, isJoined: false, userRole: "" },
  8: { name: "CS301 — Operating Systems", university: "Baku State University", description: "Process management, memory allocation, file systems, and concurrency in modern operating systems.", members: 38, totalPoints: 2800, isPrivate: false, isJoined: false, userRole: "" }
};

const tabs = [
{ id: "stream", label: "Stream", icon: MessageSquare },
{ id: "resources", label: "Resources", icon: BookOpen },
{ id: "members", label: "Members", icon: Users },
{ id: "leaderboard", label: "Leaderboard", icon: Trophy },
{ id: "events", label: "Events", icon: Calendar },
{ id: "qa", label: "Q&A", icon: HelpCircle }];


const joinRequests = [
{ id: 1, name: "Ali Aliyev", initials: "AA", university: "ADA University", className: "235.44A", time: "5m ago" },
{ id: 2, name: "Kamran Hasanli", initials: "KH", university: "Baku State University", className: "CS201", time: "1h ago" },
{ id: 3, name: "Gunel Mammadova", initials: "GM", university: "ADA University", className: "235.44A", time: "3h ago" }];


const streamPosts = [
{ id: 1, author: "Prof. Mammadov", initials: "PM", role: "admin", content: "📢 Midterm exam will be on March 20. Topics: Chapters 1-6.", time: "1h ago", likes: 12, pinned: true },
{ id: 2, author: "Leyla M.", initials: "LM", role: "member", content: "I uploaded my notes for Chapter 5 — Tree Traversals. Let me know if you find any errors!", time: "3h ago", likes: 8, attachment: "Ch5_Trees.pdf" },
{ id: 3, author: "Rashad H.", initials: "RH", role: "member", content: "Can anyone explain the difference between BFS and DFS with real examples?", time: "5h ago", likes: 5 }];


const classResources = [
{ title: "Chapter 1-4 Notes", type: "Notes", author: "Ali A.", pages: 45, rating: 4.8 },
{ title: "Sorting Algorithms Cheatsheet", type: "PDF", author: "Leyla M.", pages: 8, rating: 4.9 },
{ title: "Practice Quiz — Trees", type: "Quiz", author: "Prof. Mammadov", pages: 30, rating: 4.7 },
{ title: "Graph Theory Exercises", type: "Exercise", author: "Rashad H.", pages: 20, rating: 4.6 }];


const members = [
{ name: "Prof. Mammadov", initials: "PM", role: "Admin", major: "Computer Science" },
{ name: "Ali Aliyev", initials: "AA", role: "Member", major: "Chemical Engineering" },
{ name: "Leyla M.", initials: "LM", role: "Moderator", major: "Computer Science" },
{ name: "Rashad H.", initials: "RH", role: "Member", major: "Computer Science" },
{ name: "Nigar A.", initials: "NA", role: "Member", major: "Mathematics" },
{ name: "Kamran H.", initials: "KH", role: "Member", major: "Computer Science" }];


const leaderboard = [
{ rank: 1, name: "Ali Aliyev", initials: "AA", points: 450, delta: 0 },
{ rank: 2, name: "Leyla M.", initials: "LM", points: 420, delta: 2 },
{ rank: 3, name: "Rashad H.", initials: "RH", points: 395, delta: -1 },
{ rank: 4, name: "Nigar A.", initials: "NA", points: 380, delta: 3 },
{ rank: 5, name: "Kamran H.", initials: "KH", points: 350, delta: -2 }];


const leaderScopes = ["Class", "University", "City", "Major", "Global"];

const typeBadgeColor = {
  Notes: "bg-secondary/15 text-secondary",
  PDF: "bg-primary/10 text-primary",
  Quiz: "bg-chart-5/10 text-chart-5",
  Exercise: "bg-chart-4/10 text-chart-4"
};

const roleBadgeColor = {
  Admin: "bg-destructive/10 text-destructive",
  Moderator: "bg-chart-5/10 text-chart-5",
  Member: "bg-muted text-muted-foreground"
};

const ClassDetailView = ({ classId, onBack }) => {
  const classData = classDataMap[classId] || classDataMap[1];
  const [activeTab, setActiveTab] = useState("stream");
  const [leaderScope, setLeaderScope] = useState("Class");
  const [replyText, setReplyText] = useState("");
  const [isJoined, setIsJoined] = useState(classData.isJoined);
  const [isPending, setIsPending] = useState(false);
  const [pendingRequests, setPendingRequests] = useState(joinRequests);
  const { toast } = useToast();

  const isAdmin = classData.userRole === "admin";
  const isMod = classData.userRole === "moderator";
  const canManage = isAdmin || isMod;

  const handleJoinOrRequest = () => {
    if (classData.isPrivate) {
      setIsPending(true);
      toast({ title: "Join request sent", description: "The class admins will review your request." });
    } else {
      setIsJoined(true);
      toast({ title: "Joined!", description: `You are now a member of "${classData.name}".` });
    }
  };

  const handleAcceptRequest = (reqId, name) => {
    setPendingRequests((prev) => prev.filter((r) => r.id !== reqId));
    toast({ title: "Request accepted", description: `${name} has been added to the class.` });
  };

  const handleDeclineRequest = (reqId, name) => {
    setPendingRequests((prev) => prev.filter((r) => r.id !== reqId));
    toast({ title: "Request declined", description: `${name}'s request has been declined.` });
  };

  // Non-members: show limited view
  if (!isJoined) {
    return (
      <div className="space-y-4">
        <div className="stat-card !p-5">
          <button onClick={onBack} className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors mb-3">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to Community
          </button>
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="flex items-center gap-2">
                <h2 className="text-xl font-display font-bold text-foreground">{classData.name}</h2>
                {classData.isPrivate && <Lock className="w-4 h-4 text-muted-foreground" />}
              </div>
              <p className="text-sm text-muted-foreground mt-1 flex items-center gap-2">
                <span className="px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs font-medium">{classData.university}</span>
              </p>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{classData.description}</p>
            </div>
            <div className="flex-shrink-0">
              {isPending ?
              <button className="px-4 py-2 rounded-xl bg-chart-5/15 text-chart-5 text-xs font-semibold cursor-default">
                  ⏳ Request Pending
                </button> :

              <button
                onClick={handleJoinOrRequest}
                className="px-4 py-2 rounded-xl bg-primary text-primary-foreground text-xs font-semibold hover:bg-primary/90 transition-colors flex items-center gap-1">
                
                  {classData.isPrivate ? <><Lock className="w-3 h-3" /> Request to Join</> : <><UserPlus className="w-3.5 h-3.5" /> Join</>}
                </button>
              }
            </div>
          </div>
        </div>

        {/* Limited info for non-members */}
        <div className="stat-card !p-5">
          <h3 className="text-sm font-display font-bold text-foreground mb-4">Class Info</h3>
          <div className="grid grid-cols-2 gap-4">
            <div className="p-4 rounded-xl bg-muted/50 text-center">
              <Users className="w-5 h-5 text-secondary mx-auto mb-1.5" />
              <p className="text-lg font-bold text-foreground">{classData.members}</p>
              <p className="text-xs text-muted-foreground">Members</p>
            </div>
            <div className="p-4 rounded-xl bg-muted/50 text-center">
              <Trophy className="w-5 h-5 text-chart-4 mx-auto mb-1.5" />
              <p className="text-lg font-bold text-foreground">{classData.totalPoints.toLocaleString()}</p>
              <p className="text-xs text-muted-foreground">Total Points</p>
            </div>
          </div>
          {classData.isPrivate &&
          <p className="text-xs text-muted-foreground mt-4 text-center flex items-center justify-center gap-1.5">
              <Lock className="w-3 h-3" /> This is a private class. Join to see the full content.
            </p>
          }
        </div>
      </div>);

  }

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="stat-card !p-5">
        <button onClick={onBack} className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors mb-3">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to Community
        </button>
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-2">
              <h2 className="text-xl font-display font-bold text-foreground">{classData.name}</h2>
              {classData.isPrivate && <Lock className="w-4 h-4 text-muted-foreground" />}
            </div>
            <p className="text-sm text-muted-foreground mt-1 flex items-center gap-2">
              <span className="px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs font-medium">{classData.university}</span>
              <span className="flex items-center gap-1"><Users className="w-3 h-3" /> {classData.members} members</span>
              <span className="flex items-center gap-1"><Trophy className="w-3 h-3 text-chart-4" /> {classData.totalPoints.toLocaleString()} pts</span>
            </p>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{classData.description}</p>
          </div>
          <div className="flex gap-2 flex-shrink-0">
            <button className="px-4 py-2 rounded-xl bg-secondary/10 text-secondary text-xs font-semibold hover:bg-secondary/20 transition-colors flex items-center gap-1">
              <Users className="w-3.5 h-3.5" /> Invite
            </button>
            <button className="px-4 py-2 rounded-xl bg-secondary text-secondary-foreground text-xs font-semibold cursor-default">
              ✓ Joined
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex items-center gap-1 mt-4 overflow-x-auto border-t border-border pt-3">
          {tabs.map((t) =>
          <button key={t.id} onClick={() => setActiveTab(t.id)}
          className={`flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-medium whitespace-nowrap transition-colors ${
          activeTab === t.id ? "bg-secondary/15 text-secondary" : "text-muted-foreground hover:bg-muted hover:text-foreground"}`
          }>
              <t.icon className="w-3.5 h-3.5" /> {t.label}
            </button>
          )}
        </div>
      </div>

      {/* Join Requests — visible to admins/mods only */}
      {canManage && pendingRequests.length > 0 &&
      <div className="stat-card !p-4 border-chart-5/30">
          <h3 className="text-sm font-display font-bold text-foreground mb-3 flex items-center gap-2">
            <UserPlus className="w-4 h-4 text-chart-5" />
            Join Requests
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-chart-5/15 text-chart-5 font-bold">{pendingRequests.length}</span>
          </h3>
          <div className="space-y-2">
            {pendingRequests.map((req) =>
          <div key={req.id} className="flex items-center gap-3 p-3 rounded-xl bg-muted/50">
                <Avatar className="w-9 h-9">
                  <AvatarFallback className="bg-primary/10 text-primary text-xs font-bold">{req.initials}</AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground">
                    <span className="font-semibold">{req.name}</span>
                    <span className="text-muted-foreground font-normal"> wants to join </span>
                    <span className="font-semibold text-secondary">{req.className}</span>
                    <span className="text-muted-foreground font-normal"> {req.university} class</span>
                  </p>
                  <p className="text-[10px] text-muted-foreground">{req.time}</p>
                </div>
                <div className="flex gap-1.5 flex-shrink-0">
                  <button
                onClick={() => handleAcceptRequest(req.id, req.name)}
                className="h-8 px-3 rounded-xl bg-secondary text-secondary-foreground text-xs font-semibold hover:bg-secondary/90 transition-colors flex items-center gap-1">
                
                    <Check className="w-3 h-3" /> Accept
                  </button>
                  <button
                onClick={() => handleDeclineRequest(req.id, req.name)}
                className="h-8 px-3 rounded-xl bg-destructive/10 text-destructive text-xs font-semibold hover:bg-destructive/20 transition-colors flex items-center gap-1">
                
                    <X className="w-3 h-3" /> Decline
                  </button>
                </div>
              </div>
          )}
          </div>
        </div>
      }

      {/* Tab Content */}
      {activeTab === "stream" &&
      <div className="space-y-3">
          <div className="stat-card !p-3 flex gap-2">
            <input value={replyText} onChange={(e) => setReplyText(e.target.value)}
          placeholder="Share something with the class..."
          className="flex-1 px-4 py-2.5 rounded-xl bg-muted text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
          
            <button className="px-3 py-2.5 rounded-xl bg-primary text-primary-foreground hover:bg-primary/90 transition-colors">
              <Send className="w-4 h-4" />
            </button>
          </div>
          {streamPosts.map((post) =>
        <div key={post.id} className={`stat-card !p-4 ${post.pinned ? "border-secondary/30" : ""}`}>
              {post.pinned &&
          <div className="flex items-center gap-1 text-[10px] text-secondary font-medium mb-2">
                  <Pin className="w-3 h-3" /> Pinned
                </div>
          }
              <div className="flex items-center gap-3 mb-2">
                <Avatar className="w-8 h-8">
                  <AvatarFallback className="bg-primary/10 text-primary text-[10px] font-bold">{post.initials}</AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground">{post.author}</span>
                    {post.role === "admin" && <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-destructive/10 text-destructive font-bold uppercase">Admin</span>}
                  </div>
                  <p className="text-xs text-muted-foreground">{post.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground leading-relaxed">{post.content}</p>
              {post.attachment &&
          <div className="flex items-center gap-2 p-2.5 rounded-xl bg-muted/50 mt-2">
                  <FileText className="w-4 h-4 text-secondary" />
                  <span className="text-xs font-medium text-foreground">{post.attachment}</span>
                  <button className="ml-auto text-xs px-2 py-1 rounded-lg bg-secondary text-secondary-foreground font-medium">Open</button>
                </div>
          }
              <div className="flex items-center gap-2 mt-2 pt-2 border-t border-border/50">
                <button className="flex items-center gap-1 text-xs text-muted-foreground hover:text-red-500 transition-colors">
                  <Heart className="w-3.5 h-3.5" /> {post.likes}
                </button>
                <button className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors">
                  <MessageSquare className="w-3.5 h-3.5" /> Reply
                </button>
                <button className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors ml-auto">
                  <Share2 className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
        )}
        </div>
      }

      {activeTab === "resources" &&
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {classResources.map((r, i) =>
        <div key={i} className="stat-card !p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full uppercase ${typeBadgeColor[r.type]}`}>{r.type}</span>
                <span className="flex items-center gap-0.5 text-[10px] text-muted-foreground ml-auto">
                  <Star className="w-3 h-3 text-chart-4 fill-chart-4" /> {r.rating}
                </span>
              </div>
              <h4 className="text-sm font-display font-bold text-foreground">{r.title}</h4>
              <p className="text-xs text-muted-foreground mt-1">by {r.author} · {r.pages}p</p>
              <div className="flex gap-1.5 mt-3">
                <button className="flex-1 h-8 rounded-xl bg-primary text-primary-foreground text-xs font-semibold hover:bg-primary/90 transition-colors">Open</button>
                <button className="h-8 px-2.5 rounded-xl bg-muted text-muted-foreground text-xs hover:text-foreground transition-colors">Save</button>
              </div>
            </div>
        )}
        </div>
      }

      {activeTab === "members" &&
      <div className="stat-card !p-4">
          <div className="space-y-2">
            {members.map((m, i) =>
          <div key={i} className="flex items-center gap-3 p-2.5 rounded-xl hover:bg-muted/50 transition-colors">
                <Avatar className="w-9 h-9">
                  <AvatarFallback className="bg-primary/10 text-primary text-xs font-bold">{m.initials}</AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground">{m.name}</p>
                  <p className="text-xs text-muted-foreground">{m.major}</p>
                </div>
                <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full uppercase ${roleBadgeColor[m.role]}`}>{m.role}</span>
                <button className="text-xs px-2.5 py-1 rounded-lg bg-secondary/10 text-secondary font-medium hover:bg-secondary/20 transition-colors">Follow</button>
              </div>
          )}
          </div>
        </div>
      }

      {activeTab === "leaderboard" &&
      <div className="stat-card !p-4">
          <div className="flex gap-1 mb-4 flex-wrap">
            {leaderScopes.map((scope) =>
          <button key={scope} onClick={() => setLeaderScope(scope)}
          className={`text-xs px-3 py-1.5 rounded-lg font-medium transition-colors ${
          leaderScope === scope ? "bg-secondary/15 text-secondary" : "text-muted-foreground hover:bg-muted"}`
          }>
                {scope}
              </button>
          )}
          </div>
          <div className="space-y-2">
            {leaderboard.map((u) =>
          <div key={u.rank} className={`flex items-center gap-3 p-3 rounded-xl transition-colors ${u.rank <= 3 ? "bg-secondary/5" : "hover:bg-muted/50"}`}>
                <span className={`w-8 h-8 rounded-xl flex items-center justify-center text-sm font-bold ${
            u.rank === 1 ? "bg-secondary text-secondary-foreground" : u.rank === 2 ? "bg-chart-4/20 text-chart-4" : u.rank === 3 ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground"}`
            }>{u.rank}</span>
                <Avatar className="w-8 h-8">
                  <AvatarFallback className="bg-primary/10 text-primary text-xs font-bold">{u.initials}</AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground">{u.name}</p>
                  <p className="text-xs text-muted-foreground">{u.points} points</p>
                </div>
                {u.delta !== 0 &&
            <span className={`text-xs font-bold ${u.delta > 0 ? "text-success" : "text-destructive"}`}>
                    {u.delta > 0 ? "▲" : "▼"}{Math.abs(u.delta)}
                  </span>
            }
                <button className="text-xs px-2.5 py-1 rounded-lg bg-secondary/10 text-secondary font-medium hover:bg-secondary/20 transition-colors">Follow</button>
              </div>
          )}
          </div>
        </div>
      }

      {activeTab === "events" &&
      <div className="stat-card !p-5 text-center">
          <Calendar className="w-10 h-10 text-muted-foreground/20 mx-auto mb-3" />
          <p className="text-sm font-medium text-muted-foreground">No upcoming events for this class</p>
          <p className="text-xs text-muted-foreground/60 mt-1">Events will appear here when created</p>
        </div>
      }

      {activeTab === "qa" &&
      <div className="stat-card !p-5 text-center">
          <HelpCircle className="w-10 h-10 text-muted-foreground/20 mx-auto mb-3" />
          <p className="text-sm font-medium text-muted-foreground">No questions yet</p>
          <p className="text-xs text-muted-foreground/60 mt-1">Ask a question to get help from classmates</p>
        </div>
      }
    </div>);

};

export default ClassDetailView;